import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Col, Row} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from '../../../reducers/common/localization';
import {LABEL_PATH_BY_ORG_TYPE} from '../../../reducers/organization/organizations';

class RemoveOrgModal extends Component {
    componentWillUpdate(nextProps, nextState, nextContext) {
        if (!this.props.success && nextProps.success) {
            this.props.onCancel();
        }
    }

    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal isOpen={this.props.isOpen}
                   toggle={this.props.onCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <h6>{_.get(this.props.translation, 'orgs.remove_org_alert')}</h6>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.org_label')}:
                    </Col>
                    <Col>
                        {this.props.data.orgName}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.org_type_label')}:
                    </Col>
                    <Col>
                        {_.get(this.props.translation, sharedLabelsPath[LABEL_PATH_BY_ORG_TYPE[this.props.data.orgType]])}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.anchor_label')}:
                    </Col>
                    <Col>
                        <div>{this.props.data.anchorName + '\n'}</div>
                        <a onClick={this.handleMailtoLinkClick}
                           href={"mailto:" + this.props.data.anchorEmail}>{this.props.data.anchorEmail}</a>
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'orgs.location_label')}:
                    </Col>
                    <Col>
                        {_.get(this.props.translation, 'countries.' + this.props.data.location)}
                    </Col>
                </Row>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                </div>
            </div>
        );
    }

    handleRemove = (e) => {
        e.preventDefault();

        this.props.onRemove(this.props.data.id);
    };
}

RemoveOrgModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func,
};

export default RemoveOrgModal;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/removeOrgModal/RemoveOrgModal.js